/*global require*/
'use strict';


import "../styles/main.scss";

// import all the json and icons
function importAll (r) {
  r.keys().forEach(r);
}
importAll(require.context('./resources/', true, /\.json$/));
importAll(require.context('../styles/icons/', true, /\.svg$/));
import '../images/logo.gif';

// The original define[]

import Backbone from 'backbone';
import AppModel from 'models/App';
import AppView from 'views/App';
import $ from 'jquery';
import postal from 'postal';
import XMLLogger from 'logging/XMLLogger';



Backbone.history.start();


export {AppModel, AppView, XMLLogger, postal};